/**
 * useAppsRailCounts — the two real counts, fetched once per rail.
 *
 * A hook rather than a prop drilled from the shell, because the rail has TWO
 * hosts (`Sidebar` and `MailSidebar`) and only one of them renders at a time.
 * Passing the counts down would mean the shell fetching them for a rail it is
 * not drawing.
 *
 * ⚠️ Failure leaves the counts NULL, never 0 — the badge then does not draw.
 * "Nothing waiting" and "we could not tell you" are different statements, and a
 * sidebar badge is read at a glance without opening anything.
 */
import { useEffect, useState } from 'react';
import { fetchAppsRailCounts, EMPTY_COUNTS, type AppsRailCounts } from '../../lib/appsRail';

export function useAppsRailCounts(): AppsRailCounts {
  const [counts, setCounts] = useState<AppsRailCounts>(EMPTY_COUNTS);
  useEffect(() => {
    let alive = true;
    void (async () => {
      try {
        const c = await fetchAppsRailCounts();
        if (alive) setCounts(c);
      } catch {
        /* nulls stand; no badge is drawn */
      }
    })();
    return () => { alive = false; };
  }, []);
  return counts;
}
